import React, { useState, useEffect } from "react";
import "./CarouselBanner.css";

const CarouselBanner = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    if (!images || images.length === 0) return;
    
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % images.length);
        setIsTransitioning(false);
      }, 300);
    }, 10000);

    return () => clearInterval(interval);
  }, [images]);

  if (!images || images.length === 0) return null;

  const goToSlide = (index) => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex(index);
      setIsTransitioning(false);
    }, 400);
  };

  const goToPrev = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
      setIsTransitioning(false);
    }, 400);
  };

  const goToNext = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
      setIsTransitioning(false);
    }, 400);
  };

  return (
    <div className="banr">
      <div className="banr-stage">
        {/* Slides */}
        <div 
          className={`banr-slide ${isTransitioning ? "banr-slide--fade" : ""}`}
          key={currentIndex}
        >
          <img 
            src={images[currentIndex].image} 
            alt={`Yuvathi Sparks - Banner ${currentIndex + 1}`}
            className="banr-img"
          />
        </div>

        {/* Navigation arrows */}
        <button className="banr-arrow banr-arrow--left" onClick={goToPrev} aria-label="Previous slide">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>
        <button className="banr-arrow banr-arrow--right" onClick={goToNext} aria-label="Next slide">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>

        {/* Dots */}
        <div className="banr-dots">
          {images.map((_, idx) => (
            <button
              key={idx}
              className={`banr-dot ${idx === currentIndex ? "banr-dot--active" : ""}`}
              onClick={() => goToSlide(idx)}
              aria-label={`Go to slide ${idx + 1}`}
            >
              <span className="banr-dot-inner"></span>
            </button>
          ))}
        </div>

        {/* Progress bar */}
        <div className="banr-progress">
          <div className="banr-progress-bar" key={currentIndex}></div>
        </div>
      </div>
    </div>
  );
};

export default CarouselBanner;